var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { getColorByName } from "../../utils/color";
import { LightNeutralsColorNames, PrimaryColorNames } from "../../theme";
import clsx from "clsx";
import styles from "./Fab.module.scss";
export var FabType;
(function (FabType) {
    FabType["Primary"] = "Primary";
    FabType["Secondary"] = "Secondary";
})(FabType || (FabType = {}));
export const Fab = React.forwardRef((_a, ref) => {
    var { type, icon, text, iconClassName, iconColor: iconColorProp, iconSize: iconSizeProp, className, isMonasebati, textClassName } = _a, props = __rest(_a, ["type", "icon", "text", "iconClassName", "iconColor", "iconSize", "className", "isMonasebati", "textClassName"]);
    const Icon = icon;
    const isPrimary = type == FabType.Primary;
    const hasIconOnly = !Boolean(text);
    const iconColor = iconColorProp ||
        getColorByName(isPrimary
            ? LightNeutralsColorNames.color_neutrals_on_primary
            : PrimaryColorNames.color_primary_p_50);
    const iconSize = iconSizeProp !== null && iconSizeProp !== void 0 ? iconSizeProp : (hasIconOnly ? 20 : 24);
    return (React.createElement("div", Object.assign({ className: clsx(styles.Container, {
            [styles.Primary]: isPrimary,
            [styles.Secondary]: !isPrimary,
            [styles.IconOnly]: hasIconOnly,
            [styles.Monasebati]: isMonasebati,
        }, className), ref: ref, role: "button" }, props),
        Icon && (React.createElement(Icon, { color: iconColor, className: iconClassName, size: iconSize })),
        text && (React.createElement("span", { className: clsx(styles.Text, {
                [styles.PrimaryText]: isPrimary,
                [styles.SecondaryText]: !isPrimary,
            }, textClassName) }, text))));
});
Fab.defaultProps = {
    type: FabType.Primary,
};
//# sourceMappingURL=Fab.js.map